<template>
  <div class="downloadS-wrap">
    <div class="downloadS-bg"></div>
    <div class="downloadS">
      <div class="common-title" style="margin-bottom:40px">
        <div class="common-title-left">
          <div class="common-title1"></div>
          <div class="common-title2">办事指南</div>
          <div class="common-title3">Download guide</div>
        </div>
        <div class="common-title-right" @click="goGuide()">
          更多
        </div>
      </div>
      <div class="downloadS-items">
        <div
          style="margin-bottom:20px;overflow: hidden;"
          class="downloadS-items1"
        >
          <div
            class="downloadS-item"
            v-for="(item, index) in listA"
            :key="index"
          >
            <div class="downloadS-item1">
              {{ item.deployTime.substring(0, 10) }}
            </div>
            <div class="downloadS-item2" @click="jump(item)">
              {{ item.title }}
            </div>
            <div class="downloadS-item3">
              <svg
                class="icon"
                aria-hidden="true"
                @click="getDownload(item.guid)"
              >
                <use xlink:href="#icon-a-18_CZ_A_NW_xiazai"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      gui: "",
      list: [],
      txt: "",
      pageNum: 1, //当前页码
      pageSize: 6, // 当前页大小
      listA: []
    };
  },
  created() {
    GMS.vbus.$on("getId", res => {
      (this.gui = res.guide), this.getGuide();
    });
  },
  methods: {
    // 获得办事指南列表页
    getGuide() {
      let pram = {
        channels: JSON.stringify([this.gui]),
        filter: JSON.stringify({ deployed: 1 }),
        pageInfo: JSON.stringify({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
      };
      GMS.$http
        .post("/portal/cms/view/contents", pram, {})
        .then(res => {
          if (res.status == 200) {
            this.listA = res.data.bean;
            this.tital = res.data.total;
          }
        })
        .catch(error => {
          // this.$Message.error("获取数据异常，请联系管理员");
        });
    },
    // 获得下载列表
    getDownload(pram) {
      let Modal = true;
      GMS.$http
        .post(`/portal/cms/checkPrivileges?guid=` + pram, {
          userName: JSON.parse(sessionStorage.getItem("person"))
        })
        .then(res => {
          if (res.status == 200) {
            Modal = res.data;
          }
        });
      if (!Modal) {
        GMS.vbus.$emit("Modal-Show");
        return;
      } else {
        GMS.$http
          .get(`/portal/cms/content/?guid=` + pram)
          .then(res => {
            if (res.status == 200) {
              console.log("GG:", res);
              this.txt = res.data.datas.data.text; //正文
              this.list = res.data.datas.attachements; //附件
              for (let i = 0; i < this.list.length; i++) {
                this.download(this.list[i]);
              }
            }
          })
          .catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
          });
      }
    },
    //下载文件
    download({ guid, name = "download" }) {
      // console.log(guid);
      GMS.$http
        .get("/portal/cms/file?guid=" + guid, {
          responseType: "blob"
        })
        .then(res => {
          let blob = new Blob([res.data], {
            type: "multipart/form-data;charset=utf-8"
          });
          //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let iconv = require("iconv-lite");
          iconv.skipDecodeWarning = true; //忽略警告
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = name; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        });
    },
    //下载指南更多
    goGuide() {
      // this.$router.push("/Portal/guide");
      let navlist = JSON.parse(sessionStorage.getItem("navList"));
      let item = navlist.find(qwe => qwe.title === "办事指南");
      if (item.childList.length === 0) {
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: item.id,
            tagnum: item.childList[0].ordina
          }
        });
      }
    },
    // 跳转详情页
    jump(res) {
      let Modal = true;
      GMS.$http
        .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
          userName: JSON.parse(sessionStorage.getItem("person"))
        })
        .then(value => {
          if (value.status == 200) {
            Modal = value.data;
            if (!Modal) {
              GMS.vbus.$emit("Modal-Show");
              return;
            } else {
              this.$router.push({
                path: "/Portal/detail",
                query: {
                  title: "办事指南",
                  name: "",
                  guid: res.guid,
                  total: res.title
                }
              });
            }
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.downloadS-wrap {
  width: 100%;
  min-height: 427px;
  border-bottom: 1px solid #fcfcfc;
  overflow: hidden;
  position: relative;
  .downloadS-bg {
    position: absolute;
    width: 666px;
    height: 262px;
    background: url("../../static/webp2/底图@2x.webp");
    background-size: 666px 262px;
    bottom: -10px;
    right: 0px;
    z-index: -1;
  }
  .downloadS {
    width: 1200px;
    margin: 0 auto;
    height: inherit;
    position: relative;
  }
  .downloadS-itemmargin {
    margin-right: 90px;
  }
  .downloadS-item {
    margin-top: 20px;
    margin-right: 90px;
    float: left;
    width: 339px;
    height: 104px;
    border-bottom: 1px solid #d8d8d8;
    .downloadS-item1 {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #0081e9;
      letter-spacing: 0;
    }
    .downloadS-item2 {
      cursor: pointer;
      height: 25px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #393939;
      letter-spacing: 0;
      text-align: justify;
      line-height: 25px;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  @media screen and (max-width: 1500px) {
    .downloadS {
      width: 1200px;
    }
    .downloadS-itemmargin {
      margin-left: 90px;
      margin-right: 90px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .downloadS {
      width: 1400px;
    }
    .downloadS-itemmargin {
      margin-left: 191px;
      margin-right: 191px;
    }
  }
  @media screen and (min-width: 1800px) {
    .downloadS {
      width: 1600px;
    }
    .downloadS-itemmargin {
      margin-left: 90px;
      margin-right: 90px;
    }
    .downloadS-item {
      width: 400px;
    }
    .downloadS-itemmargin {
      margin-left: 200px;
      margin-right: 200px;
    }
  }
  .icon {
    cursor: pointer;
  }
  .common-title-right {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/downloadS.vue